"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INCOMPATIBLE_INSTALLS = exports.ALREADY_INSTALLED = exports.MISSING_HUB_SCOPES = exports.MISSING_USER_PERMISSIONS = void 0;
var MISSING_USER_PERMISSIONS = 'MISSING_USER_PERMISSIONS';
exports.MISSING_USER_PERMISSIONS = MISSING_USER_PERMISSIONS;
var MISSING_HUB_SCOPES = 'MISSING_HUB_SCOPES';
exports.MISSING_HUB_SCOPES = MISSING_HUB_SCOPES;
var ALREADY_INSTALLED = 'ALREADY_INSTALLED';
exports.ALREADY_INSTALLED = ALREADY_INSTALLED;
var INCOMPATIBLE_INSTALLS = 'INCOMPATIBLE_INSTALLS';
exports.INCOMPATIBLE_INSTALLS = INCOMPATIBLE_INSTALLS;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/installability/AppUninstallableReasons.js
// module id = 391
// module chunks = 209 210 211 212